import { useTranslation } from "react-i18next";

import { LoadingButton } from "@mui/lab";
import { Typography, styled, CircularProgress } from "@mui/material";
import {
  register as registerAPI,
  metadata as metadataAPI,
  auth as authAPI,
} from "marvin-auth-kit";
import { Form, Formik, FormikHelpers } from "formik";
import axios from "axios";

import * as Yup from "yup";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { useSnackbar } from "notistack";
import { InstantSubmit } from "../../components/form/formik/InstantSubmit";
import { RegistrationArguments } from "../../hooks/usersHooks";
import { useErrorSnackbar } from "../../hooks/errorHooks";

interface Props {}

interface RegisterConfirmForm {
  password: string;
}

export function RegisterConfirmPage(props: Props) {
  const { token } = useParams<{ token: string }>();
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const { enqueueErrorSnackbar } = useErrorSnackbar();
  const navigate = useNavigate();

  const initialValues: RegisterConfirmForm = {
    password: "",
  };
  const validationScheme = Yup.object().shape({});

  //arbitraty number, a token is very long
  if (!token || (token && token.length < 6)) {
    return <Navigate to={`/broken/app/register`} />;
  }

  async function onSubmit(
    values: RegisterConfirmForm,
    helpers: FormikHelpers<RegisterConfirmForm>
  ) {
    const { setSubmitting } = helpers;
    setSubmitting(true);
    try {
      await registerAPI.confirm(token || "");
      authAPI.applyInterceptors(axios);
      const response = await metadataAPI.get<
        RegistrationArguments["metadata"]
      >();

      enqueueSnackbar(t("message.thankYouForRegistration"), {
        variant: "info",
      });
      return navigate(`/${response.lastRegistrationConfig}/app/layers`);
    } catch (errors) {
      enqueueErrorSnackbar(errors);
    }
  }

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationScheme}
      onSubmit={onSubmit}
    >
      {({ isSubmitting }) => {
        return (
          <StyledForm>
            <Typography variant="h4" gutterBottom>
              {t("label.registerConfirm")}
            </Typography>
            <InstantSubmit />
            <CircularProgress />
            <LoadingButton
              variant="contained"
              type="submit"
              loading={isSubmitting}
            >
              {t("label.confirm")}
            </LoadingButton>
          </StyledForm>
        );
      }}
    </Formik>
  );
}

const StyledForm = styled(Form)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: 100%;

  & > * + * {
    margin-top: ${({ theme }) => `${theme.spacing(3)}!important`};
  }
`;
